import {
  CONFIRMATION,
  OFFERS,
  HOME,
  PAX,
  PAYMENT,
} from '@/hooks/usePriceFreezeRouter';

export const useCurrentPage = () =>
  [HOME, OFFERS, PAX, PAYMENT, CONFIRMATION].find((page) =>
    window.location.hash.match(page)
  );
